"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfirmationButton = void 0;
var react_1 = require("react");
var context_1 = require("../context/context");
var query_1 = require("./query");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var useTransactions_1 = require("./useTransactions");
var useSwapModal_1 = require("./useSwapModal");
var hooks_1 = require("./hooks");
var lib_1 = require("./lib");
var useConfirmationButton = function (connect) {
    var _a = (0, context_1.useTwapContext)(), translations = _a.translations, isWrongChain = _a.isWrongChain, state = _a.state, srcToken = _a.srcToken, dstToken = _a.dstToken, srcUsd = _a.srcUsd, account = _a.account;
    var swapState = state.swapState;
    var createOrderLoading = swapState === "loading";
    var onOpen = (0, useSwapModal_1.useSwapModal)().onOpen;
    var outAmountLoading = (0, lib_1.useOutAmount)().isLoading;
    var _b = (0, hooks_1.useChangeNetwork)(), changeNetwork = _b.changeNetwork, changeNetworkLoading = _b.loading;
    var noLiquidity = (0, lib_1.useNoLiquidity)();
    var shouldUnwrap = (0, lib_1.useShouldUnwrap)();
    var usdLoading = (0, bignumber_js_1.default)(srcUsd || "0").isZero();
    var srcBalanceLoading = (0, hooks_1.useSrcBalance)().isLoading;
    var warning = (0, lib_1.useSwapWarning)();
    var srcTokenFeeLoading = query_1.query.useFeeOnTransfer(srcToken === null || srcToken === void 0 ? void 0 : srcToken.address).isLoading;
    var dstTokenFeeLoading = query_1.query.useFeeOnTransfer(dstToken === null || dstToken === void 0 ? void 0 : dstToken.address).isLoading;
    var shouldOnlyWrap = (0, lib_1.useShouldOnlyWrap)();
    var _c = (0, useTransactions_1.useWrapOnly)(), wrap = _c.mutate, wrapLoading = _c.isLoading;
    var _d = (0, useTransactions_1.useUnwrapToken)(), unwrap = _d.mutate, unwrapLoading = _d.isLoading;
    var hasWarning = (0, react_1.useMemo)(function () {
        return !Object.values(warning).every(function (value) { return value === undefined; });
    }, [warning]);
    var maker = account;
    var disableWhileLaoding = outAmountLoading || usdLoading || srcBalanceLoading || srcTokenFeeLoading || dstTokenFeeLoading;
    if (createOrderLoading) {
        return {
            text: translations.placingOrder,
            onClick: onOpen,
            loading: false,
            disabled: false,
        };
    }
    if (isWrongChain)
        return {
            text: translations.switchNetwork,
            onClick: changeNetwork,
            loading: changeNetworkLoading,
            disabled: changeNetworkLoading,
        };
    if (!maker && connect)
        return {
            text: translations.connect,
            onClick: connect,
            loading: false,
            disabled: false,
        };
    if (hasWarning)
        return {
            text: warning.zeroSrcAmount ? warning.zeroSrcAmount : warning.balance || translations.placeOrder,
            onClick: undefined,
            disabled: true,
            loading: false,
        };
    if (disableWhileLaoding) {
        return { text: translations.placeOrder, onClick: undefined, loading: true };
    }
    if (noLiquidity) {
        return {
            text: translations.noLiquidity,
            disabled: true,
            loading: false,
        };
    }
    if (shouldOnlyWrap) {
        return {
            text: translations.wrap,
            onClick: wrap,
            disabled: false,
            loading: wrapLoading,
        };
    }
    if (shouldUnwrap) {
        return {
            text: translations.unwrap,
            onClick: unwrap,
            disabled: false,
            loading: unwrapLoading,
        };
    }
    return {
        text: translations.placeOrder,
        onClick: onOpen,
        loading: false,
        disabled: false,
    };
};
exports.useConfirmationButton = useConfirmationButton;
